import React, { Component } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import "./login.scss";
import { connect } from "react-redux";
import { getLogin } from "../../redux/actions/auth";
import { saveState } from "../../LocalStore/localStorage";
import { brandLogo } from "../../utils/Constants";
import { login } from "../../utils/routes";
import { Link } from "react-router-dom";

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                instructor_id: "",
                password: ""
            },
            errors: ""
        };
    }

    changeInput = e => {
        const data = { ...this.state.data };
        data[e.target.id] = e.target.value;
        this.setState({ data });
    };

    submitLogin = async e => {
        e.preventDefault();
        const { instructor_id, password } = this.state.data;
        if (instructor_id === "") {
            this.setState({ errors: "User ID field required!" });
            setTimeout(() => this.setState({ errors: "" }), 3000);
        } else {
            await this.props.dispatch(getLogin(instructor_id, password));
            if (this.props.login) {
                saveState('userInfo', this.props.login);
                window.location = "/";
            }
        }
    };

    render() {
        const { instructor_id, password } = this.state.data;
        const { errors } = this.state;

        return (
            <div className="loginBody">
                <div className="login-container">
                    <div>
                        <div className="login-wrap p-l-85 p-r-85 p-t-55 p-b-55">
                            <div className="admin-title p-b-32">
                                <div className="text-center loginLogo">
                                    <a href="/"><img src={brandLogo} alt="logo" /></a>
                                </div>
                                <br />
                                <h2 className="text-center"><small>Enter Your Phone number</small></h2>
                            </div>
                            <Form onSubmit={e => this.submitLogin(e)}>
                                {errors && (
                                    <Alert key={1} variant="danger">
                                        {errors}
                                    </Alert>
                                )}
                                <Form.Group controlId="instructor_id">
                                    <Form.Label>User Id</Form.Label>
                                    <Form.Control
                                        onChange={this.changeInput}
                                        value={instructor_id || ""}
                                        type="instructor_id"
                                        className="input"
                                        placeholder="Enter user Pnone Number"
                                        autoComplete="off"
                                    />
                                </Form.Group>

                                <Form.Group className=" m-t-42 d-flex align-items-center justify-content-between" style={{ marginBottom: "0" }}>
                                    <Link to={login} >Go to Login </Link>
                                    <Button
                                        className="login-btn"
                                        variant="primary"
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    login: state.login,
});
export default connect(mapStateToProps)(ForgotPassword);
